import { useMutation } from '@tanstack/react-query';
import {
  Setup2faDto,
  Setup2faEntity,
  UserWalletAuthService,
} from 'services/openapi';

export const useSetupTwoFaMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<Setup2faEntity, Error, Setup2faDto>({
      mutationFn: (variables: Setup2faDto) =>
        UserWalletAuthService.authControllerSetupTwoFa(variables),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
